import { render, staticRenderFns } from "./EnvelopeSingleClickActions.vue?vue&type=template&id=b4709dfc&scoped=true"
import script from "./EnvelopeSingleClickActions.vue?vue&type=script&lang=js"
export * from "./EnvelopeSingleClickActions.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeSingleClickActions.vue?vue&type=style&index=0&id=b4709dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4709dfc",
  null
  
)

export default component.exports